/* src/app/shared-module/components/sidemenu/sidemenu.component.scss */
.menu_container {
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  font-size: 1rem;
  color: white;
  padding-top: 40px;
}
.menu_container .profile_container {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 16px 12px;
}
.menu_container .profile_container ion-icon {
  height: 48px;
  width: 48px;
  margin-right: 12px;
}
.menu_container .profile_container .profile_name_container {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  margin-left: 12px;
}
.menu_container .header_icon {
  width: 36px;
  height: 36px;
  margin-right: 12px;
  border-radius: 50px;
}
.menu_container .location_container {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.menu_container .location_container .location_header_container {
  display: flex;
  flex-direction: row;
  padding: 12px;
}
.menu_container .location_container .location_header_container .locations {
  flex: 1;
  display: flex;
  align-items: center;
}
.menu_container .location_container .location_header_container ion-icon {
  margin-right: 12px;
}
.menu_container .location_container .location_header_container .visible {
  display: inline-block;
}
.menu_container .location_container .location_header_container .invisible {
  display: none;
}
.menu_container .location_container .location_accordion {
  display: none;
}
.menu_container .location_container .location_accordion.visible {
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.12);
  padding: 6px 12px;
}
.menu_container .location_container .location_accordion.visible .location_list {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 6px;
  padding: 4px 0;
  transition: opacity 0.2s ease;
}
.menu_container .location_container .location_accordion.visible .location_list.selected {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 4px 8px;
}
.menu_container .location_container .location_accordion.visible .location_list.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.menu_container .location_container .location_accordion.visible .location_list .gym_logo {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}
.menu_container .location_container .location_accordion.visible .location_list .location-spinner {
  width: 18px;
  height: 18px;
  margin-left: auto;
  --color: white;
}
.menu_container .menu_list_container .menu_list {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;
}
.menu_container .menu_list_container .menu_list ion-icon {
  margin-right: 12px;
}
.menu_container .menu_list_container .menu_list ion-label {
  flex: 1;
}
.profile_explorer {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6705882353);
  font-weight: normal;
  margin-top: 4px;
}
.location_explorer {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6705882353);
  font-weight: normal;
  margin-top: 12px;
}
.gym_name {
  margin-left: 12px;
}
.badge_menu {
  background-color: var(--ion-color-danger);
}
/*# sourceMappingURL=sidemenu.component.css.map */
